import aumLogo from "../components/pictures/logos/AUM-Logo.png";

export const educationsData = [
  // Add data for other educations here
  {
    date: "2013 - 2018",
    icon: (
      <img
        src={aumLogo}
        alt="AUM Logo"
        style={{
          marginBottom: 0,
          paddingBottom: 0,
          position: "relative",
          width: "100%",
          borderRadius: "50%",
          justifyContent: "center",
        }}
      />
    ),
    jobTitle: "educations.bachelor_of_science_in_computer_engineering.jobTitle",
    companyName:
      "educations.bachelor_of_science_in_computer_engineering.companyName",
    link: "https://aum.edu.kw/",
  },
];
